import Api from ".";
import ApiEndPoint from "./ApiEndpoint";
import {
  showLoader,
  stopLoader,
  setRequestStatus,
} from "../redux/slices/generalSlice";
import { setFileUploadsData } from "../redux/slices/ordersHistorySlice";
import { setOrdersData } from "../redux/slices/ordersListingSlice";
import { base64ToExcel, successMessage } from "../helpers/general";
import { setBrandListingData } from "../redux/slices/brandListingSlice";
import { setBrandName } from "../redux/slices/brandSlice";
import { fetchStatus } from "../redux/slices/statusListingSlice";
import { setStartDate, setEndDate } from "../redux/slices/dateSlice";
import { setStatus } from "../redux/slices/statusSlice";
import { setUserBrandId, setUserBrand } from "../redux/slices/userSlice";

export const fileUploadHistory =
  ({
    page = 0,
    size = 20,
    brandId = "",
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());

      const url =
        brandId !== ""
          ? `${ApiEndPoint.upload}${ApiEndPoint.history}?page=${page}&size=${size}&brandId=${brandId}`
          : `${ApiEndPoint.upload}${ApiEndPoint.history}?page=${page}&size=${size}`;
      const {
        data: { data },
      } = await Api.get(url);

      console.log("data of fileUploadHistory", data);
      dispatch(setFileUploadsData(data));
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const getOrders =
  ({
    data: val,
    page = 0,
    size = 20,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.ondemand}${ApiEndPoint.filter}?page=${page}&size=${size}`;
      const {
        data: { data },
      } = await Api.post(url, { ...val });
      console.log("data of getOrders", data);
      dispatch(setOrdersData(data));
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const getBrandOrders =
  ({
    data: val,
    page = 0,
    size = 20,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.reliance}${ApiEndPoint.filter}?page=${page}&size=${size}`;
      const {
        data: { data },
      } = await Api.post(url, { ...val });
      console.log("data of getOrders", data);
      dispatch(setOrdersData(data?.data));
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const uploadBulkOrder =
  ({
    formData,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.upload}${ApiEndPoint.bulk}`;
      const headers = {
        "Content-Type": "multipart/form-data",
      };
      const {
        data: { data },
      } = await Api.post(url, formData, headers);
      console.log("data of upload", data);
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const downloadExcelReport =
  ({
    trackerId,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.download}${ApiEndPoint.error}?trackerId=${trackerId}`;
      const {
        data: { data },
      } = await Api.get(url);
      console.log("data of downloadExcelErrorReport", data);
      if (data?.value) base64ToExcel(data?.value, "Report.xlsx");
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      dispatch(
        setRequestStatus(
          successMessage(data?.message || "Report downloaded successfully")
        )
      );
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const downloadExcelReportWithStatus =
  ({
    data: val,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.ondemand}${ApiEndPoint.download}`;
      const {
        data: { data },
      } = await Api.post(url, { ...val });
      console.log("data of downloadExcelReportWithStatus", data);
      if (data?.value) base64ToExcel(data?.value, "Report.xlsx");
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      dispatch(
        setRequestStatus(
          successMessage(data?.message || "Report downloaded successfully")
        )
      );
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const downloadExcelReportWithStatusRil =
  ({
    data: val,
    loader,
    localCallback = () => null,
    successMethod = () => null,
  }) =>
  async (dispatch) => {
    try {
      if (loader) dispatch(showLoader());
      const url = `${ApiEndPoint.reliance}${ApiEndPoint.download}`;
      const {
        data: { data },
      } = await Api.post(url, { ...val });
      console.log("data of downloadExcelReportWithStatus", data);
      if (data?.value) base64ToExcel(data?.value, "Report.xlsx");
      successMethod();
      if (loader) dispatch(stopLoader());
      localCallback();
      dispatch(
        setRequestStatus(
          successMessage(data?.message || "Report downloaded successfully")
        )
      );
      return data;
    } catch (e) {
      if (loader) dispatch(stopLoader());
      localCallback();
      return e.response;
    }
  };

export const getBrandList = () => async (dispatch) => {
  try {
    const url = `${ApiEndPoint.brand}${ApiEndPoint.list}${ApiEndPoint.v1}`;
    const {
      data: { data },
    } = await Api.post(url, {});

    dispatch(setBrandListingData(data?.brandData));
    console.log("data?.brandData", data?.brandData);
    if (data?.brandData?.length > 0) {
      dispatch(setUserBrand(data?.brandData?.[0]?.brandName));
      dispatch(setUserBrandId(data?.brandData?.[0]?.brandId));
    }
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getStatusList = () => async (dispatch) => {
  try {
    const url = `${ApiEndPoint.orderStatus}${ApiEndPoint.list}${ApiEndPoint.v1}`;
    const {
      data: { data },
    } = await Api.get(url);
    console.log("ewfeg", data);
    dispatch(fetchStatus(data?.statuses));
    return data;
  } catch (error) {
    return error.response;
  }
};

export const brandName = (brand) => async (dispatch) => {
  console.log("brandName", brand);
  dispatch(setBrandName(brand));
  dispatch(setUserBrandId(brand?.id));
};

export const setStartTime1 = (date) => async (dispatch) => {
  console.log("setStartDate", date);
  dispatch(setStartDate(date));
};
export const setEndTime1 = (date) => async (dispatch) => {
  console.log("setEndDate", date);
  dispatch(setEndDate(date));
};

export const setSelectedStatus = (status) => async (dispatch) => {
  console.log("statusss", status);
  dispatch(setStatus(status));
};

// eslint-disable-next-line
export default {
  fileUploadHistory,
  getOrders,
  uploadBulkOrder,
  downloadExcelReport,
  downloadExcelReportWithStatus,
  getBrandOrders,
  getBrandList,
  getStatusList,
  brandName,
  setStartTime1,
  setEndTime1,
  setStatus,
  downloadExcelReportWithStatusRil,
};
